import { render, staticRenderFns } from "./payDetail.vue?vue&type=template&id=0bc258b0&scoped=true"
import script from "./payDetail.vue?vue&type=script&lang=js"
export * from "./payDetail.vue?vue&type=script&lang=js"
import style0 from "./payDetail.vue?vue&type=style&index=0&id=0bc258b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc258b0",
  null
  
)

export default component.exports